export const stageTitles: string[] = [
  'Product details',
  'Goal and price',
  'Commission',
];
